import { render } from "./store-config.vue?vue&type=template&id=282fdbb8"
import script from "./store-config.vue?vue&type=script&setup=true&lang=js"
export * from "./store-config.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "/home/runner/work/linker-marketplace-web/linker-marketplace-web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/v2/modules/integrations/pages/link-marketplace/components/odoo/store-config.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "282fdbb8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('282fdbb8', __exports__)) {
    console.log('reload')
    api.reload('282fdbb8', __exports__)
  }
  
  module.hot.accept("./store-config.vue?vue&type=template&id=282fdbb8", () => {
    console.log('re-render')
    api.rerender('282fdbb8', render)
  })

}


export default __exports__